import React from 'react';
import { ENUM_LOCALE_CODE } from 'global.enums';
import { DocumentDirection } from 'global.interfaces';
import i18next from 'i18next';

export interface IAppContext {
  language: ENUM_LOCALE_CODE;
  documentDirection: DocumentDirection;
  setLanguage: (locale: ENUM_LOCALE_CODE) => void;
  i18next: typeof i18next;
}

export const AppContext = React.createContext<IAppContext>({
  language: ENUM_LOCALE_CODE.enUS,
  documentDirection: 'ltr',
  setLanguage: () => {
    console.error('setLanguage is not defined');
  },
  i18next,
});
